import { observer } from 'mobx-react-lite'
import { Row, Col } from 'antd'
import i from '../../../../translations/i'
import { __product } from '../__product'
import React from "react";
import { QuillEditor } from "../../../../components/QuillEditor";

export const ProductText = observer(() => {

  return(
    <>
      <Row gutter={[20, 20]} align="bottom">
        <Col span={24}>
          <label className="formLabel">{i.t('def:Text')}</label>

          <QuillEditor
            value={__product.item.text}
            onChange={(e: any) => __product.item.text = e}
          />
        </Col>
      </Row>
    </>
  )
})